import { useState } from "react";
import { Seo } from "@/components/common/Seo";
import { PageHeader } from "@/components/common/PageHeader";
import { AppCard } from "@/components/apps/AppCard";
import { HealthDisclaimer } from "@/components/common/HealthDisclaimer";
import { Reveal } from "@/components/common/Reveal";
import { visibleApps } from "@/data/apps";

const filters = [
  { id: "all", label: "All" },
  { id: "published", label: "Available" },
  { id: "coming-soon", label: "Coming soon" },
];

export default function AppsIndex() {
  const [filter, setFilter] = useState("all");
  const list = filter === "all" ? visibleApps : visibleApps.filter((a) => a.status === filter);

  return (
    <>
      <Seo
        title="Apps"
        path="/apps"
        description="Every mobile app built by tutinsapp studio — available now and in development."
      />
      <PageHeader
        label="Catalogue"
        lines={["Our apps."]}
        intro="Each app below is a self-contained entry in our content registry. Open one to see its features, platforms, support, legal pages and disclaimers."
      >
        <div className="mt-10 flex flex-wrap gap-2" role="tablist" aria-label="Filter apps">
          {filters.map((f) => (
            <button
              key={f.id}
              type="button"
              role="tab"
              aria-selected={filter === f.id}
              data-testid={`apps-filter-${f.id}`}
              onClick={() => setFilter(f.id)}
              className="rounded-full px-4 py-2 text-sm transition-colors duration-300"
              style={
                filter === f.id
                  ? { background: "var(--accent)", color: "#08090d" }
                  : { border: "1px solid var(--line)", color: "#9CA3AF" }
              }
            >
              {f.label}
            </button>
          ))}
        </div>
      </PageHeader>

      <section className="pb-24 sm:pb-32">
        <div className="shell">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="apps-grid">
            {list.map((app, i) => (
              <AppCard key={app.id} app={app} index={i} />
            ))}
          </div>
          {list.length === 0 && (
            <p data-testid="apps-empty-state" className="text-sm text-gray-500">
              No apps in this category yet.
            </p>
          )}

          <Reveal delay={0.1}>
            <div className="mt-16">
              <HealthDisclaimer testId="apps-health-disclaimer" />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
